"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;